<template>
  <div class="row">
    <div class="col-6" style="height: 360px">
      <Line :data="line" :options="line_options"/>
    </div>
    <div class="col-6" style="height: 360px">
      <Doughnut :data="doughnut" :options="doughnut_options"/>
    </div>

  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Line } from 'vue-chartjs'

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title
} from 'chart.js'

ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title
)

export default {
  name      : 'DashboardTraffic',
  components: {Doughnut, Line},
  props     : ['traffic', 'traffic_log'],
  data() {
    return {
      colors          : ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
      doughnut_options: {
        responsive         : true,
        maintainAspectRatio: false,
        animation          : false,
        plugins            : {
          legend : {
            position: 'bottom',
            display : false
          },
          tooltip: {
            position: 'nearest'
          }
        }
      },
      line_options    : {
        responsive         : true,
        maintainAspectRatio: false,
        interaction        : {
          mode     : 'index',
          intersect: false
        },
        animation          : false,

        plugins: {
          legend : {
            position: 'bottom',
            display : false
          },
          tooltip: {
            position: 'nearest'
          }
        }
      }
    }
  },
  computed: {
    doughnut() {
      return {
        labels  : this.doughnut_labels,
        datasets: [
          {
            backgroundColor: this.colors,
            data           : this.doughnut_dataset
          }
        ]
      }
    },
    line() {
      return {
        labels  : this.line_labels,
        datasets: this.line_dataset
      }
    },
    traffic_total() {
      if (!this.traffic_log) {
        return []
      }
      return Object.keys(this.traffic_log).map(i => {
        let result = {code: i}
        let found  = this.traffic.find(t => t.code === i)
        if (found) {
          result = {
            code: i,
            name: found.name
          }
        }
        result.total = Object.values(this.traffic_log[i]).reduce((a, b) => a + b, 0)
        return result
      })
    },
    doughnut_labels() {
      return this.traffic_total.length ? this.traffic_total
          .filter(i => i.total > 0).sort(i => i.total)
          .map((i, index) => i.name ? i.name : '' + index) : []
    },
    doughnut_dataset() {
      if (!this.traffic_total) {
        return []
      }
      return this.traffic_total
          .filter(i => i.total > 0).sort(i => i.count)
          .map(i => (i.total).toFixed(0))
    },
    line_labels() {
      return Array.apply(null, Array(7)).map((i, index) => {
        let date = new Date();
        date.setDate(date.getDate() - 6 + index)
        let m = ((date.getUTCMonth() + 1) + '').padStart(2, '0')
        let d = (date.getDate() + '').padStart(2, '0')
        return `${date.getFullYear()}-${m}-${d}`
      })
    },
    line_dataset() {
      if (!this.traffic_log) {
        return []
      }
      let result = Object.keys(this.traffic_log)
      result     = result.map((i, index) => {
        let color  = this.colors[index % this.colors.length];
        let lFound = this.traffic.find(x => x.code === i)
        return {
          label          : lFound ? lFound.name : i,
          data           : Object.values(this.traffic_log[i]).reverse(),
          borderColor    : color,
          backgroundColor: color
        }
      })
      return result
    }
  }
}
</script>

<style scoped>

</style>